/*
 * File: DashboardDealCard.tsx
 * Project: a-a
 * File Created: Wednesday, 6th November 2024 9:22:42 pm
 * Author: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Last Modified: Friday, 25th July 2025 10:29:33 pm
 * Modified By: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Copyright 2020 - 2024 Mutual Mobile, Mutual Mobile
 */
import React from 'react';
import CustomCard from '../../CustomCard/CustomCard';
import { Box, Skeleton, Typography, useTheme } from '@mui/material';
import zeplinColor from '../../../../theme/Color';

const formatPercent = (percent: string): string => {
  // Remove unwanted characters (+, -, %)
  const numericValue = parseFloat(percent.replace(/[+%]/g, ''));

  if (isNaN(numericValue)) return ''; // Return empty if not a valid number

  // Determine the sign (+ or -)
  const sign = percent.includes('-') ? '' : '+';

  // Handle formatting based on the number of digits
  if (numericValue >= 100 && numericValue % 1 === 0) {
    // Case: 100.00 -> 100
    return `${sign}${Math.floor(numericValue)}`;
  } else if (numericValue >= 100) {
    // Case: 100.01 -> Efficient display
    return `${sign}${numericValue.toFixed(2)}`;
  } else {
    // Case: Round to 2 decimal places for numbers < 100
    return `${sign}${numericValue.toFixed(2)}`;
  }
};

const DashboardDealCard = ({
  color,
  val,
  text,
  percent,
}: {
  color: string;
  val: string | undefined;
  percent?: 'string';
  text: string;
}) => {
  const theme = useTheme();
  console.log(val, text);
  return (
    <CustomCard
      styles={{
        borderRadius: '16px',
        padding: { xs: '16px 16px 16px 16px', xl: '24px' },
        backgroundColor: color,
        // width: '195.5px',
        // height: '115px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        // gap: '16px',s
        // alignItems:''
        // overflow: 'hidden',
        flex: 1,
        gap: { xs: '8px', xl: '16px' },
      }}
    >
      {/* <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', gap: '16px' }}> */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: '16px',
          marginBottom: '0',
        }}
      >
        {val !== undefined ? (
          <Typography
            variant='responsiveDisplay4'
            color={zeplinColor.BasicBlack}
            style={{ flex: 1 }}
          >
            {val}
          </Typography>
        ) : (
          <Skeleton
            variant='text'
            sx={{
              fontSize: theme.typography.body2,
              width: '100%',
              // Optionally adjust other styles here
            }}
          />
        )}
        {percent === undefined ? (
          ''
        ) : percent ? (
          <CustomCard
            styles={{
              borderRadius: '50px',
              padding: '4px 8px',
              backgroundColor: percent?.includes('-') ? zeplinColor.Error : zeplinColor.Success,
              // width: '509px',
              height: '22px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <Typography variant='responsiveLabel1'>
              {/* {`${percent?.includes('-') ? '' : '+'} ${percent?.slice(0, 6).replace('%', '')}`}% */}
              {formatPercent(percent)}%
            </Typography>
          </CustomCard>
        ) : (
          <Skeleton
            variant='text'
            sx={{
              fontSize: theme.typography.body2,
              width: '100%',
              // Optionally adjust other styles here
            }}
          />
        )}
      </Box>
      <Typography
        variant='responsiveBody3'
        color={zeplinColor.BasicBlack}
        sx={{
          marginTop: '0', // Push to bottom of flex space
          marginBottom: '0', // No margin at bottom
          lineHeight: 1, // Set line height exactly to font size
          paddingBottom: '0', // No padding at bottom
          paddingTop: '0', // No padding at top
          height: 'auto', // Let height be determined by content
          display: 'block', // Use block display
          // fontSize: theme.typography.responsiveBody3.fontSize, // Explicit font size
        }}
      >
        {text}
      </Typography>
      {/* </Box> */}
    </CustomCard>
  );
};

export default DashboardDealCard;
